// extracted by mini-css-extract-plugin
export var button = "_5o-0";
export var icon = "_5o-1";